/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function InlineObject6FromJSON(json) {
    return InlineObject6FromJSONTyped(json, false);
}
export function InlineObject6FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'adIds': !exists(json, 'adIds') ? undefined : json['adIds'],
        'copyOnly': !exists(json, 'copyOnly') ? undefined : json['copyOnly'],
        'templateId': !exists(json, 'templateId') ? undefined : json['templateId'],
    };
}
export function InlineObject6ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'adIds': value.adIds,
        'copyOnly': value.copyOnly,
        'templateId': value.templateId,
    };
}
